/**
 * 格式化时间 
 */

export function fomatTime(date, ctype) {
  if (date == '' || !date) {
    return '';
  }
  // 处理纯时间字符串（如 '16:26:00'）
  let _date;
  if (typeof date === 'string' && date.match(/^\d{2}:\d{2}:\d{2}$/)) {
    // 纯时间字符串，拼接当前日期
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    _date = new Date(`${year}-${month}-${day} ${date}`);
  } else {
    _date = new Date(date);
  }
  // 检查日期是否有效
  if (isNaN(_date.getTime())) {
    console.error('无效的日期格式:', date);
    return '';
  }
  var y = _date.getFullYear();
  var m = _date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = _date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = _date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = _date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  var second = _date.getSeconds();
  second = second < 10 ? ('0' + second) : second;
  const weekdays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
  const weekday = weekdays[_date.getDay()];
  switch (ctype) {
    case 'yy':
      return y;
    case 'mm':
      // 单独月份不加0
      return _date.getMonth() + 1;
    case 'dd':
      // 单独日期不加0
      return _date.getDate();
    case 'month':
    case 'yymm':
      return y + '-' + m;
    case 'date':
    case 'yymmdd':
      return y + '-' + m + '-' + d;
    case 'yymm01':
      // 当前月份第一天
      return y + '-' + m + '-01';
    case 'time':
    case 'yymmddhhmmss':
      return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
    case 'hhmm':
      return h + ':' + minute;
    case 'hhmmss':
      return h + ':' + minute + ':' + second;
    case 'weekdays':
      return `${y}年${m}月${d}日 ${weekday}`;
    case '-1day':
      // 过去一天
      return getPreviousDate(date,1);
    case '-7day':
      // 过去一周
      return getPreviousDate(date,7);
    case '-15day':
      // 过去十五天
      return getPreviousDate(date,15);
  }
  // if(ctype == 'date'){
  //   return y + '-' + m + '-' + d ;
  // }else if(ctype == 'time'){
  //   return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second ;
  // }
}

// 获取new Date() 前几天
export function getPreviousDate(date, numOfDays) {
  if (date == '' || !date) {
    return '';
  }
  const _date = new Date(date); // 拷贝新对象，不修改原对象
  _date.setDate(_date.getDate() - numOfDays);
  var year = _date.getFullYear();
  var month = _date.getMonth() + 1;
  month = month < 10 ? ('0' + month) : month;
  var day = _date.getDate();
  day = day < 10 ? ('0' + day) : day;
  return year + "-" + month + "-" + day;
}


// date 代表指定的日期，格式：2018-09-27
// day 传-1表始前一天，传1表始后一天
// JS获取指定日期的前一天，后一天
export function getNextDate(date, day) {
  var dd = new Date(date);
  dd.setDate(dd.getDate() + day);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
  var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
  return y + "-" + m + "-" + d;
};

// 获取当前日期的上一个月
export function getLastMonth(now) {
  // let now = new Date();
  // 当前年月的日
  let nowDate = now.getDate();
  //当前月份完整日期 (Thu Jul 07 2022 12:03:37 GMT+0800 (中国标准时间))
  let lastMonth = new Date(now.getTime());
  // 设置上一个月（这里不需要减1） getMonth()返回表示月份的数字 setMonth()设置月份参数
  lastMonth.setMonth(lastMonth.getMonth());
  // 设置为0，默认为当前月的最后一天
  lastMonth.setDate(0);
  // 上一个月的天数
  let daysOflastMonth = lastMonth.getDate();
  // 设置上一个月的日期，如果当前月的日期大于上个月的总天数，则为最后一天
  // 例如当前是3月31，而2月只有28或29天，则取2月的最后一天
  lastMonth.setDate(nowDate > daysOflastMonth ? daysOflastMonth : nowDate);
  //调用格式化日期函数
  lastMonth = getNowFormatDate(lastMonth);
  return lastMonth;
}


// 获取当前日期的下一个月
export function getNextMonth(now) {
  // let now = new Date(), //获取当前时间
  let year = now.getFullYear(), //获取当前时间的年份
    month = now.getMonth(), //获取当前时间的月份
    day = now.getDate(), //获取当前时间的日
    newYear = year,
    nextMonth = parseInt(month + 2), //获取当前月份的一个月以后的月份
    currentDay = day;
  /* 				days = new Date(year, month, 0) //将获取到的年月赋值给days
      days = days.getDate() //获取当前年月的日 */

  //考虑到12月要是获取一个月以后，就是一月，年份需要加一 ，一年没有13月，所以%12，取得来年1月
  if (nextMonth > 12) {
    newYear = parseInt(newYear) + 1;
    nextMonth = parseInt(nextMonth) % 12;
  }

  let nextDay = new Date(newYear, nextMonth, 0); //将获取到的年月赋值给nextDay
  nextDay = nextDay.getDate(); //获取当前月份的一个月以后的日

  /* 			获取了当前年份的日和1个月以后的日，为的就是判断如果前一个月是有31号，
      后一个月没有，就将一个月以后的日期取到，赋值给currentDay */
  currentDay = currentDay > nextDay ? nextDay : currentDay;

  nextMonth = nextMonth < 10 ? "0" + nextMonth : nextMonth;

  currentDay = currentDay < 10 ? "0" + currentDay : currentDay;

  return `${newYear}-${nextMonth}-${currentDay}`;
}
//格式化日期函数
function getNowFormatDate(date) {
  //  let date = new Date() //获取当前完整日期

  let year = date.getFullYear(), // 返回日期的年
    month = date.getMonth() + 1, // 月份 返回的月份小1个月   记得月份+1
    d = date.getDate(), // 返回的是 几号
    hour = date.getHours(), // 时
    minute = date.getMinutes(), // 分
    second = date.getSeconds(), // 秒
    w = date.getDay(), // 周一返回的是 1 周六返回的是 6 但是 周日返回的是 0
    week = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];

  month = month < 10 ? "0" + month : month;

  d = d < 10 ? "0" + d : d;

  hour = hour < 10 ? "0" + hour : hour;

  minute = minute < 10 ? "0" + minute : minute;

  second = second < 10 ? "0" + second : second;

  return `${year}-${month}-${d}`;
}


// 获取当前年份最后一天
export function getLastDayOfYear() {
  // 创建当前日期对象
  const now = new Date();
  // 获取当前年份
  const currentYear = now.getFullYear();
  // 创建当前年份最后一天的日期对象 (12月31日)
  const lastDayOfYear = new Date(currentYear, 11, 31);
  // 格式化输出（年-月-日）
  const year = lastDayOfYear.getFullYear();
  const month = String(lastDayOfYear.getMonth() + 1).padStart(2, '0');
  const day = String(lastDayOfYear.getDate()).padStart(2, '0');
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
}
// 获取日期
function getDay(d, num) {
  const date = new Date(new Date(d).setDate(new Date(d).getDate() + num))
  const year = date.getFullYear()
  const month = (date.getMonth() + 1 + "").padStart(2, "0")
  const day = (date.getDate() + "").padStart(2, "0")
  return `${year}-${month}-${day}`
}

// 是否是闰年
function isLeap(year) {
  return (year % 4 == 0 && year % 100 != 0) || year % 400 == 0
}

// 返回去年日期
export function YearDate(d, num) {
  const date = new Date(d)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const lastYear = year + num
  const thisYearisLeap = isLeap(year)
  const lastYearIsLeap = isLeap(lastYear)
  // 特殊情况：去年是否是闰年 或 今年是闰年且为12月31日
  if (lastYearIsLeap || (thisYearisLeap && month == 12 && day == 31)) return getDay(d, 366 * num)
  return getDay(d, 365 * num)
}


// 从日期数组中获取最晚的日期
export function getLatestDendDate(objArray,dateField) {
  // 1. 入参校验：确保是数组且非空
  if (!Array.isArray(objArray) || objArray.length === 0) {
    return null;
  }

  // 2. 过滤出ddate有效且能转成合法日期的对象
  const validItems = objArray.filter(item => {
    // 检查item是对象、有ddate字段、且ddate能转成有效Date
    if (typeof item !== 'object' || item === null || !item[dateField]) {
      return false;
    }
    const date = new Date(item[dateField]);
    return !isNaN(date.getTime()); // 验证日期是否合法
  });

  // 无有效数据返回null
  if (validItems.length === 0) {
    return null;
  }

  // 3. 找出ddate最晚的对象（核心逻辑）
  const latestItem = validItems.reduce((prev, curr) => {
    const prevDate = new Date(prev[dateField]);
    const currDate = new Date(curr[dateField]);
    return currDate > prevDate ? curr : prev;
  }, validItems[0]);

  // 4. 根据需求返回对应格式（这里默认返回完整对象，可按需调整）
  return fomatTime(latestItem.ddate,'date');
  // 若只需返回日期字符串：return latestItem.ddate;
  // 若只需返回Date对象：return new Date(latestItem.ddate);
}

/**
 * 获取今日时间范围 {dstart: 今日, dend: 今日} YYYY-MM-DD
 */
export function getTodayRange() {
  const now = new Date();
  const today = fomatTime(now, 'date');
  return { dstart: today, dend: today };
}

/**
 * 获取本周时间范围（周一为第一天，周日为最后一天） YYYY-MM-DD
 */
export function getThisWeekRange() {
  const now = new Date();
  const day = now.getDay(); // 0(周日) 1(周一) ... 6(周六)
  // 计算距离周一的偏移量：周日偏移-6天，周一偏移0天，周二偏移-1天...
  const mondayOffset = day === 0 ? -6 : 1 - day;
  // 本周一日期
  const monday = new Date(now);
  monday.setDate(now.getDate() + mondayOffset);
  const weekStart = fomatTime(monday, 'date');
  // 本周日 = 本周一 + 6天（基于你已有的getNextDate）
  const weekEnd = getNextDate(weekStart, 6);
  return { dstart: weekStart, dend: weekEnd };
}

/**
 * 获取本月时间范围 {dstart: 当月1号, dend: 当月最后一天} YYYY-MM-DD
 */
export function getThisMonthRange() {
  const now = new Date();
  // 本月第一天：YYYY-MM-01（复用你已有的fomatTime的yymm01类型）
  const monthStart = fomatTime(now, 'yymm01');
  // 本月最后一天：下月1号的前一天（基于你已有的getNextDate）
  const nextMonthFirst = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const monthEnd = getNextDate(fomatTime(nextMonthFirst, 'date'), -1);
  return { dstart: monthStart, dend: monthEnd };
}

/**
 * 获取本年时间范围 {dstart: 当年1月1号, dend: 当年12月31号} YYYY-MM-DD
 */
export function getThisYearRange() {
  const now = new Date();
  const year = now.getFullYear();
  // 本年第一天
  const yearStart = `${year}-01-01`;
  // 本年最后一天（复用你已有的getLastDayOfYear函数）
  const yearEnd = getLastDayOfYear();
  return { dstart: yearStart, dend: yearEnd };
}